<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler } from '@/utils/common'

export default {
  name: 'Comp46',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-46">
    <module-title :title="moduleOption.title" margin-bottom="30" />
    <div class="comp-transverse-2 modules-id-46-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 2)"
        :key="`modules-id-46-item-${i}`"
        class="item"
        :class="{'sec-item': i === 1}"
        @click="onModuleItem(v)"
      >
        <el-image
          v-if="i === 1"
          class="comp46-img"
          :src="require('imgs/modules/comp46-img.png')"
          alt="cover"
          fit="cover"
        />
        <div class="img-box">
          <el-image class="item-img" :src="v.photo | imgPath" alt="cover" fit="cover" />
        </div>
        <p v-if="i === 0" class="item-memo h-line-3">{{ filtersRichtext(v.memo) }}</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-46-content {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  column-gap: 14px;
  .comp46-img {
    width: 140px;
    height: 40px;
    margin: 40px 0 60px 100px;
  }
  .item {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .img-box {
      width: 380px;
      height: 208px;
      border-radius: 7px;
      border: 3px solid #fff4ce;
      .item-img {
        width: 374px;
        height: 202px;
        border-radius: 5px;
      }
    }
    .item-memo {
      width: 340px;
      font-size: 14px;
      font-weight: 600;
      color: #000;
      line-height: 18px;
      margin-top: 45px;
      text-indent: 2em;
      letter-spacing: 1px;
    }
  }
  .sec-item {
    .img-box {
      width: 270px;
      height: 178px;
      border-radius: 7px;
      border: 3px solid #fff4ce;
      .item-img {
        width: 264px;
        height: 172px;
        border-radius: 5px;
      }
    }
  }
}
</style>
